import { Paper, Skeleton, Stack } from "@mui/material";
import { Grid } from "@mui/system";

/**
 * Placeholder for the trace panel only - the brand picker above it stays on
 * screen, so there is nothing here standing in for it.
 */
const BrandTraceSkeleton = () => (
  <Stack spacing={2} sx={{ mt: 2 }}>
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Grid container spacing={2}>
        {Array.from({ length: 8 }).map((_, index) => (
          <Grid key={index} size={{ xs: 6, md: 3 }}>
            <Skeleton width={90} />
            <Skeleton width="70%" height={24} />
          </Grid>
        ))}
      </Grid>
    </Paper>
    {Array.from({ length: 3 }).map((_, index) => (
      <Skeleton key={index} variant="rounded" height={56} />
    ))}
  </Stack>
);

export default BrandTraceSkeleton;
